export const notificationsObjectFactory = notifications => {
  let notificationsObj = {};
  notifications.map(notification => {
    notification.categories.map(category => {
      notificationsObj[category] = {
        notification: notification.notification,
        type: notification.type
      };
    });
  });
  return notificationsObj;
};

// normalize opacity to a value between 0 and 1
const normalizeOpacity = transparency => {
  if (!transparency || typeof transparency !== 'number') return 1;
  if (transparency < 0) return 0;
  if (transparency > 100) return 1;
  return (transparency / 100).toFixed(2);
};

// normalize border radius to a value between 0 and 100 and return a string with 'px'
const normalizeBorderRadius = border => {
  let new_border = border;
  if (!border || typeof border !== 'number') new_border = 0;
  else if (border < 0) new_border = 0;
  else if (border > 100) new_border = 100;
  return `${new_border}px`;
};

export const popUpFactory = popUp => {
  // return null if popUp is not an object or doesn't have a title
  if (!popUp || typeof popUp !== 'object' || !popUp['Title']) return null;

  return {
    id: popUp['id'],
    danger: popUp['Danger'] || false,
    size: popUp['Pop_Up_Size'] || 'medium',
    content: {
      title: popUp['Title'],
      subtitle: popUp['Subtitle'],
      body: popUp['Body'],
      image_url: popUp['Image_URL']
    },
    background: {
      border_radius: normalizeBorderRadius(popUp['Background_Border_Radius']),
      image_url: popUp['Background_Image_URL']
        ? `url(${popUp['Background_Image_URL']})`
        : 'none',
      image_fit: popUp['Background_Image_Fit'] || 'cover',
      image_position: popUp['Background_Image_Position'] || 'center',
      color: popUp['Background_Color'] || '#fff',
      opacity: normalizeOpacity(popUp['Background_Opacity'])
    },
    show_primary_button: !!(
      popUp['Primary_Button_Text'] &&
      (popUp['Primary_Button_External_URL'] ||
        popUp['Primary_Button_Internal_Route'] ||
        popUp['Primary_Button_Reloads_Page'])
    ),
    show_secondary_button: !!(
      popUp['Show_Secondary_Button'] &&
      popUp['Secondary_Button_Text'] &&
      (popUp['Secondary_Button_External_URL'] ||
        popUp['Secondary_Button_Internal_Route'] ||
        popUp['Secondary_Button_Reloads_Page'])
    ),
    show_dismiss_button: popUp['Show_Dismiss_Button'],
    primary_button: {
      label: popUp['Primary_Button_Text'],
      variant: popUp['Primary_Button_Type'] || 'primaryDarkened',
      url: popUp['Primary_Button_External_URL'],
      path: popUp['Primary_Button_Internal_Route'],
      is_external: !!popUp['Primary_Button_External_URL'],
      reload_page: !!popUp['Primary_Button_Reloads_Page']
    },
    secondary_button: {
      label: popUp['Secondary_Button_Text'],
      variant: popUp['Secondary_Button_Type'] || 'secondary',
      url: popUp['Secondary_Button_External_URL'],
      path: popUp['Secondary_Button_Internal_Route'],
      is_external: !!popUp['Secondary_Button_External_URL'],
      reload_page: !!popUp['Secondary_Button_Reloads_Page']
    },
    dont_show_again_checkbox: popUp['Don_t_Show_Again_Checkbox'],
    start_date: popUp['Start_Date']
  };
};
